// Check for other istances
if (!window.accordionManagerLoaded) {

     document.addEventListener('click', function(e) {
        // 1. Handle Desktop "Read More"
        const readMoreBtn = e.target.closest('#quote-callout--profile-desktop h5:last-child');
        if (readMoreBtn) {
            const section = readMoreBtn.closest('.shopify-section--quote-callout');
            const detailText = section.querySelector('#quote-callout--profile-desktop-detail');
            
            const isVisible = detailText.style.display === 'block';
            detailText.style.display = isVisible ? 'none' : 'block';
            readMoreBtn.textContent = isVisible ? 'Read more.' : 'Read less.';
        }

        // 2. Handle Mobile "Read More"
        const mobileBtn = e.target.closest('#quote-callout--profile-mobile-detail p:nth-child(3)');
        if (mobileBtn) {
            const section = mobileBtn.closest('.shopify-section--quote-callout');
            const mobileDetail = section.querySelector('#quote-callout--profile-mobile-detail p:nth-child(2)');
            
            const isVisible = mobileDetail.style.display === 'block';
            mobileDetail.style.display = isVisible ? 'none' : 'block';
            mobileBtn.textContent = isVisible ? 'READ MORE' : 'READ LESS';
        }
    });

    // Stop Other Istances
    window.accordionManagerLoaded = true;
}